import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import { Button } from "../../ui";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useFetchForumdetailQuery,
  useFetchAllSportsQuery,
} from "../../store/api/apiSlice";
import LeftSideAnimation from "../../components/animations/LeftAndRightSideAnimation";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { HashLoader } from "react-spinners";
import { toast } from "react-toastify";
import { useFetchProfilesQuery } from "../../store/api/apiSlice";
const token = JSON.parse(localStorage.getItem("token"));

const ForumDetail = () => {
  const { data: sportsData } = useFetchAllSportsQuery();

  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const { data: profileData, isLoading: isProfileLoading } =
    useFetchProfilesQuery();
  const navigate = useNavigate();
  const { id } = useParams();
  const currentUserId = token ? token.userId : null;

  const { data: forumData, isLoading, refetch } = useFetchForumdetailQuery(id);
  const [profile, setProfile] = useState({
    image: "image",
    isAdmin: false,
    avatarName: "avatarName",
  });
  useEffect(() => {
    if (profileData) {
      setProfile({
        image: profileData.user.image,
        isAdmin: profileData.user.isAdmin,
        avatarName: profileData.user.avatarName,
      });
    }
  }, [profileData]);

  const [comment, setComment] = useState("");
  const [sendButton, setSendButton] = useState(false);
  const [isForumMember, setIsForumMember] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [newMessage, setNewMessage] = useState(null);
  const [previousMessages, setPreviousMessages] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [matchedSportFile, setMatchedSportFile] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [forumMembers, setForumMembers] = useState(
    forumData?.forum?.members || []
  );
  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const [error, setError] = useState(null);
  const handleSendMessage = async () => {
    setSendButton(true);
    const xAuthToken = token ? token.token : null;
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const currentUserFirstName = profileData.user.firstName || "alon";
    const currentUserLastName = profileData.user.lastName || "musk";
    const isOnlyEmoji = (text) => {
      const strippedText = text.replace(/<[^>]*>/g, "").trim();
      return /^[\p{Emoji}\s]+$/u.test(strippedText);
    };

    let messageType;
    if (isOnlyEmoji(comment)) {
      messageType = "emoji";
    } else {
      messageType = "text";
    }
    const messageData = {
      userId: currentUserId,
      forumId: id,

      receiverId: "rec123",
      message: comment,
      messageType: messageType,
      type: "forum",
      status: true,
      userFirstName: currentUserFirstName,
      userLastName: currentUserLastName,
    };

    try {
      const response = await axios.post(
        `${baseUrl}/api/messages/create`,
        messageData,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );

      if (response.data.message === "Message Created Successfully") {
        setSendButton(false);
        toast.success("Message Send Successfully");
        fetchPreviousMessages();
        setShowSuccessMessage(true);
        setComment("");
        setNewMessage(response.data.new_message);
      }
    } catch (error) {
      setSendButton(false);
      toast.error("Comment field required");
      setError("Failed to send message. Please try again.");
    }
  };

  useEffect(() => {
    if (!isLoading && forumData) {
      setIsForumMember(
        forumData?.forum?.members?.some(
          (member) => member.userId === currentUserId
        )
      );
    }
    if (error) {
    }
  }, [forumData, isLoading, error]);
  useEffect(() => {
    if (forumData && sportsData) {
      const matchedSport = sportsData.sports.find(
        (sport) => sport.name === forumData.forum.sportsName
      );
      if (matchedSport) {
        setMatchedSportFile(matchedSport.sportsFile);
      }
    }
  }, [forumData, sportsData]);
  const handleCommentChange = (value) => {
    if (value.includes("@")) {
      setShowTooltip(true);
      setTooltipPosition({ top: 100, left: 50 });
    } else {
      setShowTooltip(false);
      setSelectedIndex(-1);
    }

    setComment(value);
  };
  const userNames =
    forumData?.forum?.members?.map(
      (member) => `${member.userFirstName} ${member.userLastName}`
    ) || [];

  const handleKeyDown = (e) => {
    if (showTooltip) {
      if (e.key === "ArrowDown") {
        setSelectedIndex((prevIndex) => (prevIndex + 1) % userNames.length);
        e.preventDefault();
      } else if (e.key === "ArrowUp") {
        setSelectedIndex(
          (prevIndex) => (prevIndex - 1 + userNames.length) % userNames.length
        );
        e.preventDefault();
      } else if (e.key === "Enter" && selectedIndex >= 0) {
        insertName(userNames[selectedIndex]);

        e.preventDefault();
      }
    }
  };

  const insertName = (name) => {
    const newComment = comment.replace(/@.*$/, `${name} `);
    setComment(newComment);
    setShowTooltip(false);
    setSelectedIndex(-1);
  };

  const handleBlur = () => {
    setShowTooltip(false);
    setSelectedIndex(-1);
  };
  const handleParticipateClick = async () => {
    const xAuthToken = token ? token.token : null;
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const response = await axios.post(
        `${baseUrl}/api/forum-members/create`,
        {
          forumId: id,
          userId: currentUserId,
          role: "general",
          status: true,
        },
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );
      if (response.data?.message === "Forum Member Created Successfully") {
        toast.success("Forum Member Created Successfully");
        refetch();
        const newMember = {
          _id: response.data.new_member_id,
          userFirstName: profileData.user.firstName || "alon",
          userLastName: profileData.user.lastName || "musk",
          userId: currentUserId,
          role: "general",
          status: true,
        };
        setForumMembers((prevMembers) => [...prevMembers, newMember]);
        fetchPreviousMessages();
        setIsForumMember(true);
        setShowSuccessMessage(true);
        setShowErrorMessage(false);
        fetchPreviousMessages();
      }
    } catch (err) {
      setShowErrorMessage(true);
    }
  };
  const handleDeleteMessage = async (messageId) => {
    const xAuthToken = token ? token.token : null;
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const response = await axios.delete(
        `${baseUrl}/api/messages/delete/${messageId}`,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );

      if (response.data?.message === "Message Deleted Successfully") {
        toast.success("Message deleted successfully");
        fetchPreviousMessages();
      }
    } catch (error) {
      toast.error("Failed to delete message. Please try again.");
    }
  };

  const handleRemoveMember = async (memberId) => {
    const xAuthToken = token ? token.token : null;
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const response = await axios.delete(
        `${baseUrl}/api/forum-members/delete/${memberId}`,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );
      toast.success("Member removed successfully");

      refetch();
    } catch (error) {
      toast.error("Failed to remove member. Please try again.");
    }
  };

  const fetchPreviousMessages = async () => {
    const xAuthToken = token ? token.token : null;
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    try {
      const response = await axios.get(
        `${baseUrl}/api/messages/forum-messages?forumId=${id}`,
        {
          headers: {
            "x-auth-token": xAuthToken,
            "secret-key": secretKey,
          },
        }
      );
      setPreviousMessages(response.data.messages);
    } catch (error) {
      setError("Failed to fetch messages. Please try again.");
    }
  };
  useEffect(() => {
    fetchPreviousMessages();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <HashLoader color="#00b386" size={70} />
      </div>
    );
  }

  return (
    <>
      <Header />
      <section className="py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="bg-white">
                <div className="heading_box d-flex justify-content-between align-items-center">
                  <FadeInAnimation>
                    <h4 className="froumtitle">{forumData?.forum?.title}</h4>
                  </FadeInAnimation>
                  <Button
                    className="ml-auto"
                    style={{ marginLeft: "auto" }}
                    onClick={() => navigate("/forumlist")}
                  >
                    Back
                  </Button>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-9">
                        <div className="mob-flex mb-2">
                          <LeftSideAnimation x={-100}>
                            <h4 className="concoursetitle3">
                              <img
                                src="/images/vninter.png"
                                alt="Profile"
                                className="ballicon1"
                              />{" "}
                              <span className="text-black">
                                {forumData?.forum?.schoolName}
                              </span>
                            </h4>
                          </LeftSideAnimation>
                          <LeftSideAnimation x={-100}>
                            <h4 className="concoursetitle2">
                              <img
                                src={
                                  matchedSportFile
                                    ? `${baseUrl}/${matchedSportFile}`
                                    : "/images/placeholder.png"
                                }
                                alt="Profile"
                                className="ballicon1"
                              />
                              <span> {forumData?.forum?.sportsName}</span>
                            </h4>
                          </LeftSideAnimation>
                        </div>
                        <LeftSideAnimation x={-100}>
                          <p className="concoursepara">
                            {forumData?.forum?.description}
                          </p>
                        </LeftSideAnimation>
                        <LeftSideAnimation x={-100}>
                          <p className="dateformatcourse">
                            <img
                              src="/images/calendar.png"
                              className="img-fluid calendaricon"
                            />
                            <span className="span1">
                              Date Posted:{" "}
                              {new Date(
                                forumData?.forum?.createdAt
                              ).toLocaleDateString()}
                            </span>
                            <span className="span1 ms-3">
                              {forumData?.forum?.messages} Comments
                            </span>
                          </p>
                        </LeftSideAnimation>
                      </div>
                      <div className="col-md-3">
                        <div className="p-3 pt-0 position-relative h-200 bggray">
                          <LeftSideAnimation x={100}>
                            <h4 className="concoursetitle pt-2">Participant</h4>
                          </LeftSideAnimation>
                          <ul className="participantlist">
                            {forumData?.forum?.members?.length > 0 ? (
                              forumData.forum.members.map((member) => (
                                <li
                                  key={member._id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "0px 5px 0px 0px",
                                    borderBottom: "1px solid #f0f0f0",
                                    listStyleType: "none",
                                  }}
                                >
                                  <LeftSideAnimation x={100}>
                                    <h5
                                      style={{
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        color: "#333",
                                        margin: "0",
                                      }}
                                    >
                                      {isForumMember || profile.isAdmin ? (
                                        <Link
                                          to={`/chat?userId=${member.userId}&name=${member.userFirstName} ${member.userLastName}`}
                                          style={{
                                            textDecoration: "none",
                                            color: "#007bff",
                                          }}
                                        >
                                          {`${member.userFirstName} ${member.userLastName}`}
                                        </Link>
                                      ) : (
                                        <span style={{ color: "#333" }}>
                                          {`${member.userFirstName} ${member.userLastName}`}
                                        </span>
                                      )}
                                    </h5>
                                  </LeftSideAnimation>
                                  {profile.isAdmin && (
                                    <Button
                                      onClick={() =>
                                        handleRemoveMember(member._id)
                                      }
                                      style={{
                                        backgroundColor: "#e74c3c",
                                        color: "white",
                                        border: "none",
                                        padding: "3px 10px",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                        transition:
                                          "background-color 0.3s ease",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.currentTarget.style.backgroundColor =
                                          "#c0392b")
                                      }
                                      onMouseOut={(e) =>
                                        (e.currentTarget.style.backgroundColor =
                                          "#e74c3c")
                                      }
                                    >
                                      X
                                    </Button>
                                  )}
                                </li>
                              ))
                            ) : (
                              <></>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {previousMessages.map((message) => (
                  <div className="row mt-3" key={message._id}>
                    <div className="col-md-1">
                      <LeftSideAnimation x={-100}>
                        <img
                          src={`${baseUrl}/${message.userImage}`}
                          alt={message.userFirstName}
                          className="img-fluid commentimage"
                        />
                      </LeftSideAnimation>
                    </div>
                    <div className="col-md-11 ps-0">
                      <div
                        className="bggreycomment"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <LeftSideAnimation x={-100}>
                            <h4>
                              {message.userFirstName} {message.userLastName}
                            </h4>
                          </LeftSideAnimation>
                          <LeftSideAnimation x={-100}>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: message.message,
                              }}
                            ></p>
                          </LeftSideAnimation>
                          <LeftSideAnimation x={-100}>
                            <p
                              style={{
                                fontSize: "0.9em",
                                color: "grey",
                                fontWeight: "normal",
                              }}
                            >
                              By {message.userFirstName} {message.userLastName}{" "}
                              at {formatDate(message.createdAt)}
                            </p>
                          </LeftSideAnimation>
                        </div>
                        {profile.isAdmin && (
                          <Button
                            onClick={() => handleDeleteMessage(message._id)}
                            style={{
                              backgroundColor: "#e74c3c",
                              color: "white",
                              border: "none",
                              padding: "3px 8px",
                              borderRadius: "50%",
                              cursor: "pointer",
                              fontSize: "12px",
                              transition: "background-color 0.3s ease",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "25px",
                              height: "25px",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#c0392b")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#e74c3c")
                            }
                          >
                            X
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                <div>
                  {showTooltip && (
                    <div
                      style={{
                        left: "20%",
                        width: "max-content",
                        position: "absolute",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        backgroundColor: "#f7f6f6ba",
                        border: "1px solid #ccc",
                        padding: "-1px",
                        zIndex: 1000,
                        padding: "4px",
                      }}
                    >
                      {userNames.map((name, index) => (
                        <div
                          key={index}
                          style={{
                            backgroundColor:
                              selectedIndex === index
                                ? "#d3d3d3"
                                : "transparent",
                            cursor: "pointer",
                          }}
                          onMouseDown={() => insertName(name)}
                        >
                          {name}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {(isForumMember || profile.isAdmin) && (
                  <div className="row mt-3">
                    <div className="col-md-1">
                      <LeftSideAnimation x={-100}>
                        <img
                          src={`${baseUrl}/${profile.image}`}
                          alt={profile.avatarName}
                          className="img-fluid commentimage"
                        />
                      </LeftSideAnimation>
                    </div>

                    <div className="col-md-11 ps-0">
                      <div className="bggreycomment">
                        <ReactQuill
                          value={comment}
                          onBlur={handleBlur}
                          onKeyDown={handleKeyDown}
                          onChange={handleCommentChange}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "10px",
                          }}
                        >
                          <Button
                            loading={sendButton}
                            className="btn btn-send mt-2 d-block ms-auto"
                            type="button"
                            onClick={handleSendMessage}
                          >
                            Send
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!isForumMember && !profile.isAdmin && (
                  <>
                    <p
                      className="participateText"
                      style={{ marginTop: "40px" }}
                    >
                      {" "}
                      You need to be participant in order to post comments in
                      this forum.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        className="apply-button"
                        onClick={handleParticipateClick}
                      >
                        Participate
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForumDetail;
